import React, { useState, useMemo } from "react";
import { X, Search, Check } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { LANGUAGES, LANG_MAP } from "@/data/languages";

export function LanguageSelect({ value = [], onChange, testId = "language-select" }) {
  const { lang } = useLang();
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);

  const filtered = useMemo(() => {
    const s = q.trim().toLowerCase();
    return LANGUAGES.filter(
      (l) =>
        !value.includes(l.code) &&
        (!s || l.fr.toLowerCase().includes(s) || l.en.toLowerCase().includes(s) || l.code.includes(s))
    ).slice(0, 8);
  }, [q, value]);

  const add = (code) => { onChange([...value, code]); setQ(""); };
  const remove = (code) => onChange(value.filter((c) => c !== code));

  return (
    <div className="relative">
      <div className="rounded-2xl border border-line bg-white px-3 py-2.5">
        {value.length > 0 && (
          <div className="flex flex-wrap gap-2 mb-2">
            {value.map((code) => (
              <span key={code} data-testid={`lang-chip-${code}`} className="inline-flex items-center gap-1 rounded-full bg-amber/15 text-ink px-2.5 py-1 text-sm font-medium">
                {LANG_MAP[code] ? LANG_MAP[code][lang] : code}
                <button type="button" onClick={() => remove(code)}><X className="w-3.5 h-3.5" /></button>
              </span>
            ))}
          </div>
        )}
        <div className="flex items-center gap-2">
          <Search className="w-4 h-4 text-ink/40 shrink-0" />
          <input
            data-testid={testId}
            value={q}
            onChange={(e) => { setQ(e.target.value); setOpen(true); }}
            onFocus={() => setOpen(true)}
            onBlur={() => setTimeout(() => setOpen(false), 150)}
            placeholder={lang === "fr" ? "Rechercher une langue…" : "Search a language…"}
            className="flex-1 bg-transparent outline-none text-sm py-1"
          />
        </div>
      </div>
      {open && filtered.length > 0 && (
        <div className="absolute z-20 left-0 right-0 mt-1 rounded-2xl border border-line bg-white shadow-lg overflow-hidden max-h-56 overflow-y-auto">
          {filtered.map((l) => (
            <button
              key={l.code}
              type="button"
              data-testid={`lang-option-${l.code}`}
              onMouseDown={(e) => { e.preventDefault(); add(l.code); }}
              className="w-full text-left px-4 py-2.5 text-sm hover:bg-paper flex items-center justify-between"
            >
              {l[lang]}
              <Check className="w-4 h-4 text-sage opacity-0" />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
